var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8686 4.39382L7.91888 9.34357L2.96911 4.3938L1.83774 5.52517L7.91886 11.6063L14 5.52519L12.8686 4.39382Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic-arrow-down.ffe880714a66457b5b46555af0e7de88.svg";
export { ForwardRef as ReactComponent };